<div class="flex flex-col">
  <div class="grid grid-cols-2 gap-2 items-center">
    <div>
      <div *ngIf="!addingExperience" class="flex flex-col md:flex-row gap-1">
        <span class="font-semibold">Professional</span>
        <span class="font-semibold">Experiences</span>
      </div>

      <div *ngIf="isTempExperience" class="flex flex-col md:flex-row gap-1">
        <span class="font-semibold">Add</span>
        <span class="font-semibold">Experience</span>
      </div>

      <div *ngIf="addingExperience && !isTempExperience" class="flex flex-col md:flex-row gap-1">
        <span class="font-semibold">Update</span>
        <span class="font-semibold">Experience</span>
      </div>
    </div>

    <div class="gap-2 flex justify-self-end items-center" *ngIf="!addingExperience">
      <span *ngIf="experiences.length > 0 && !locked">Click Entry to Manage</span>
      <span *ngIf="locked">Click Entry to View</span>

      <button type="button" *ngIf="!locked || isChange || renewal"
              mat-button color="primary" (click)="createExperience()">Add</button>

      <button type="button" mat-button color="primary"
        (click)="getExperience(!includeArchived)">{{includeArchived? 'Hide Archived' : 'Show Archived'}}</button>
    </div>
  </div>

  <div class="flex flex-col" *ngIf="!addingExperience" [@slideRight]>
    <mat-table [dataSource]="experienceSource" matSort #experienceSort="matSort" aria-label="Professional Experience" class="portal-table">
      <ng-container matColumnDef="certification">
        <mat-header-cell *matHeaderCellDef mat-sort-header="">Certification</mat-header-cell>
        <mat-cell *matCellDef="let experience" (click)="selectExperience(experience)">
          <span class="mobile-label">Cert</span>
          {{ experience.certification }}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="dateReceived">
        <mat-header-cell *matHeaderCellDef>Date Received</mat-header-cell>
        <mat-cell *matCellDef="let experience" (click)="selectExperience(experience)">
          <span class="mobile-label">Date Received</span>
          <span>{{ experience.dateReceived | date }}</span>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="certificateNumber">
        <mat-header-cell *matHeaderCellDef>Phone</mat-header-cell>
        <mat-cell *matCellDef="let experience" (click)="selectExperience(experience)">
          <span class="mobile-label">Certificate Number</span>
          <div class="flex flex-col">
            <span>{{ experience.certificateNumber }}</span>
          </div>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="actions">
        <mat-header-cell *matHeaderCellDef></mat-header-cell>
        <mat-cell *matCellDef="let experience">
          <div class="flex flex-row justify-start items-center">
            <button type="button"
                    *ngIf="!locked"
                    mat-icon-button
                    [color]="experience.archived? 'primary' : 'warn'"
                    (click)="archiveExperience(experience, !experience.archived)"
                    [matTooltip]="experience.archived? 'Un-Archive Experience' : 'Archive Experience'"
                    matTooltipShowDelay="500" matTooltipHideDelay="200">
              <mat-icon *ngIf="!experience.archived" fontIcon="archive"></mat-icon>
              <mat-icon *ngIf="experience.archived" fontIcon="unarchive"></mat-icon>
            </button>
            <button *ngIf="!locked" type="button" mat-icon-button color="warn" (click)="confirmDelete(experience.id)"
              matTooltip="Delete Management Experience" matTooltipShowDelay="500" matTooltipHideDelay="200">
              <mat-icon>delete</mat-icon>
            </button>
          </div>
        </mat-cell>
      </ng-container>
      <mat-header-row *matHeaderRowDef="experienceColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: experienceColumns" class="portal-interactive-row"
               [ngClass]="row.archived? 'portal-archived' : ''"></mat-row>
    </mat-table>
    <mat-paginator [pageSizeOptions]="[5, 10, 20]" #experiencePaginator="matPaginator">
    </mat-paginator>
  </div>

  <div class="flex flex-col pt-4" *ngIf="addingExperience" [@slideRight]>
    <form [formGroup]="experienceForm">
      <div class="flex flex-col gap-2">

        <div class="flex flex-col md:flex-row gap-2 items-end">
          <div class="flex flex-col gap-2 md:w-1/2">
            <span class="font-semibold">
              Nursing/Medical/Therapeutic License, Certificate or Degree
              (Please include proof of Licensure, Certificate, or Degree)
            </span>
            <mat-form-field>
              <mat-label>Documentation</mat-label>
              <input matInput formControlName="certification">
              <mat-error *ngIf="experienceForm.get('certification').invalid">
                Documentation is required
              </mat-error>
            </mat-form-field>
          </div>

          <div class="flex flex-col md:w-1/2 gap-2">
            <span class="font-semibold">Date Received</span>
            <mat-form-field>
              <input placeholder="mm/dd/yyyy" formControlName="dateReceived" matInput [matDatepicker]="dateReceived" [max]="sharedService.today"/>
              <mat-datepicker-toggle matSuffix [for]="dateReceived"></mat-datepicker-toggle>
              <mat-datepicker #dateReceived>
                <mat-datepicker-actions>
                  <button mat-raised-button color="primary" matDatepickerApply>Apply</button>
                  <button mat-button matDatepickerCancel>Cancel</button>
                </mat-datepicker-actions>
              </mat-datepicker>
              <mat-error *ngIf="experienceForm.get('dateReceived').invalid">
                Date is required
              </mat-error>
            </mat-form-field>
          </div>
        </div>

        <div class="flex flex-col md:flex-row gap-2">
          <div class="flex flex-col gap-2 md:w-1/2">
            <span class="font-semibold">
              License/Certificate Number
            </span>
            <mat-form-field>
              <mat-label>Cert Number</mat-label>
              <input matInput formControlName="certificateNumber">
            </mat-form-field>
          </div>

          <div class="flex flex-col md:w-1/2 gap-2">
            <span class="font-semibold">License/Certificate Expiration Date</span>
            <mat-form-field>
              <input placeholder="mm/dd/yyyy" formControlName="certificateExpirationDate" matInput [matDatepicker]="expirationDate"/>
              <mat-datepicker-toggle matSuffix [for]="expirationDate"></mat-datepicker-toggle>
              <mat-datepicker #expirationDate>
                <mat-datepicker-actions>
                  <button mat-raised-button color="primary" matDatepickerApply>Apply</button>
                  <button mat-button matDatepickerCancel>Cancel</button>
                </mat-datepicker-actions>
              </mat-datepicker>
            </mat-form-field>
          </div>
        </div>

        <div class="flex flex-col md:flex-row gap-2 items-center">
          <label id="licensed-in-oregon">
            Are you currently Licensed/Certified in Oregon?
          </label>
          <mat-radio-group aria-labelledby="licensed-in-oregon" formControlName="licensedInOregon">
            <mat-radio-button [value]="true">
              Yes
            </mat-radio-button>
            <mat-radio-button [value]="false">
              No
            </mat-radio-button>
          </mat-radio-group>
        </div>

        <div class="flex flex-col md:flex-row gap-2 items-center">
          <label id="licensed-in-another-state">
            Are you currently Licensed/Certified in another state?
          </label>
          <mat-radio-group aria-labelledby="licensed-in-another-state" formControlName="licensedInAnotherState">
            <mat-radio-button [value]="true">
              Yes
            </mat-radio-button>
            <mat-radio-button [value]="false">
              No
            </mat-radio-button>
          </mat-radio-group>

          <div class="flex flex-col gap-2 md:w-1/2" *ngIf="experienceForm.get('licensedInAnotherState').value">
            <span class="font-semibold"><strong>State</strong></span>
            <mat-form-field>
              <mat-label>State</mat-label>
              <mat-select formControlName="otherLicensedState">
                <mat-option *ngFor="let state of sharedService.states" value={{state}}>{{state}}</mat-option>
              </mat-select>
              <mat-error *ngIf="experienceForm.get('otherLicensedState').invalid">
                Please select a state
              </mat-error>
              </mat-form-field>
            </div>
        </div>
      </div>
    </form>

    <div class="gap-2 flex justify-end items-center">
      <button type="button" *ngIf="experienceForm.valid && experience.id > 0 && (!locked || isChange || renewal)"
              mat-button color="primary" (click)="saveExperience()">Save</button>

      <button type="button" *ngIf="experience.id > 0 && (!locked || isChange)"
              mat-button color="warn" (click)="confirmDelete(experience.id)">Delete</button>

      <button type="button" *ngIf="experience.id > 0 && !isTempExperience && !locked"
              mat-button color="warn" (click)="archiveExperience(experience, !experience.archived)">{{ experience.archived? 'Un-Archive' : 'Archive' }}</button>

      <button type="button" mat-button color="warn" (click)="toggleExperienceForm(false)">Close</button>
    </div>
  </div>
</div>
